import styled from 'styled-components';
export const StripMultiColors = styled.hr`
  float: left;
  height: ${({
  size
}) => `${size}px`};
  position: ${({
  position
}) => position};
  width: 100%;
  overflow: hidden;
  border: none;
  background-image: linear-gradient(
    to right,
    #ffff4a 0,
    #fcd000 4%,
    #ffc112 8%,
    #ffc112 11%,
    #ff8a00 16%,
    #ff5f5f 22%,
    #ff253a 28%,
    #ff37a8 37%,
    #c739ff 49%,
    #a400e1 56%,
    #2eceff 72%,
    #0086ff 80%,
    #72f772 94%,
    #00d604
  );
`;